module.exports = __webpack_public_path__ + "static/img/look_refuse.295d125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/look_refuse.png
// module id = DPLO
// module chunks = 0